export const gallery = [
  {
    id: "gallery-01",
    image: "https://readdy.ai/api/search-image?query=elegant%20Korean%20female%20news%20anchor%20in%20navy%20gown%20on%20red%20carpet%2C%20warm%20spotlights%2C%20glamorous%20event%20backdrop%2C%20editorial%20photography&width=800&height=1000&seq=gallery-01&orientation=portrait",
    streamerId: "seo-yuna",
    streamerName: "徐允儿",
    theme: "红毯",
    date: "2026-10-15",
  },
  {
    id: "gallery-02",
    image: "https://readdy.ai/api/search-image?query=casual%20Korean%20female%20host%20in%20cozy%20cafe%20by%20window%2C%20warm%20natural%20light%2C%20soft%20neutral%20interior%2C%20editorial%20lifestyle%20photography&width=800&height=1000&seq=gallery-02&orientation=portrait",
    streamerId: "im-sera",
    streamerName: "林世拉",
    theme: "日常",
    date: "2026-10-15",
  },
  {
    id: "gallery-03",
    image: "https://readdy.ai/api/search-image?query=Korean%20female%20music%20show%20host%20in%20pastel%20dress%20posing%20in%20studio%2C%20bright%20soft%20lights%2C%20clean%20neutral%20backdrop%2C%20editorial%20photography&width=800&height=1000&seq=gallery-03&orientation=portrait",
    streamerId: "han-sia",
    streamerName: "韩诗雅",
    theme: "广告拍摄",
    date: "2026-10-15",
  },
  {
    id: "gallery-04",
    image: "https://readdy.ai/api/search-image?query=Korean%20female%20variety%20host%20in%20yellow%20knit%20outfit%20laughing%20outdoors%2C%20warm%20afternoon%20light%2C%20soft%20bokeh%20background%2C%20editorial%20photography&width=800&height=1000&seq=gallery-04&orientation=portrait",
    streamerId: "jung-daeun",
    streamerName: "郑多恩",
    theme: "日常",
    date: "2026-10-14",
  },
  {
    id: "gallery-05",
    image: "https://readdy.ai/api/search-image?query=chic%20Korean%20female%20host%20in%20cream%20trench%20coat%20at%20fashion%20week%2C%20warm%20spotlights%2C%20luxury%20venue%20backdrop%2C%20editorial%20photography&width=800&height=1000&seq=gallery-05&orientation=portrait",
    streamerId: "baek-jia",
    streamerName: "白智雅",
    theme: "红毯",
    date: "2026-10-14",
  },
  {
    id: "gallery-06",
    image: "https://readdy.ai/api/search-image?query=Korean%20female%20talk%20show%20host%20in%20black%20dress%20with%20dramatic%20studio%20lighting%2C%20moody%20neutral%20backdrop%2C%20editorial%20photography&width=800&height=1000&seq=gallery-06&orientation=portrait",
    streamerId: "kim-hana",
    streamerName: "金荷娜",
    theme: "广告拍摄",
    date: "2026-10-13",
  },
  {
    id: "gallery-07",
    image: "https://readdy.ai/api/search-image?query=Korean%20female%20morning%20anchor%20in%20white%20turtleneck%20by%20bright%20window%2C%20soft%20daylight%2C%20minimal%20neutral%20interior%2C%20editorial%20photography&width=800&height=1000&seq=gallery-07&orientation=portrait",
    streamerId: "kang-jisu",
    streamerName: "姜智秀",
    theme: "日常",
    date: "2026-10-13",
  },
  {
    id: "gallery-08",
    image: "https://readdy.ai/api/search-image?query=Korean%20female%20reporter%20in%20denim%20jacket%20on%20urban%20street%2C%20warm%20evening%20light%2C%20city%20bokeh%20background%2C%20editorial%20photography&width=800&height=1000&seq=gallery-08&orientation=portrait",
    streamerId: "oh-seeun",
    streamerName: "吴世恩",
    theme: "日常",
    date: "2026-10-14",
  },
  {
    id: "gallery-09",
    image: "https://readdy.ai/api/search-image?query=Korean%20female%20financial%20anchor%20in%20grey%20suit%20posed%20professionally%2C%20clean%20neutral%20studio%20backdrop%2C%20soft%20editorial%20lighting%2C%20photography&width=800&height=1000&seq=gallery-09&orientation=portrait",
    streamerId: "choi-subin",
    streamerName: "崔秀彬",
    theme: "广告拍摄",
    date: "2026-10-11",
  },
  {
    id: "gallery-10",
    image: "https://readdy.ai/api/search-image?query=graceful%20Korean%20female%20host%20in%20silk%20gown%20at%20award%20ceremony%2C%20warm%20golden%20lights%2C%20luxury%20red%20carpet%20backdrop%2C%20editorial%20photography&width=800&height=1000&seq=gallery-10&orientation=portrait",
    streamerId: "seo-yuna",
    streamerName: "徐允儿",
    theme: "红毯",
    date: "2026-10-10",
  },
  {
    id: "gallery-11",
    image: "https://readdy.ai/api/search-image?query=fresh%20Korean%20female%20rookie%20host%20in%20lavender%20cardigan%20smiling%20outdoors%2C%20warm%20daylight%2C%20soft%20green%20background%2C%20editorial%20photography&width=800&height=1000&seq=gallery-11&orientation=portrait",
    streamerId: "yoon-chaeyoung",
    streamerName: "尹彩英",
    theme: "日常",
    date: "2026-10-10",
  },
  {
    id: "gallery-12",
    image: "https://readdy.ai/api/search-image?query=Korean%20female%20entertainment%20host%20in%20coral%20silk%20blouse%20posing%20in%20studio%2C%20bright%20soft%20lights%2C%20clean%20cream%20backdrop%2C%20editorial%20photography&width=800&height=1000&seq=gallery-12&orientation=portrait",
    streamerId: "im-sera",
    streamerName: "林世拉",
    theme: "广告拍摄",
    date: "2026-10-15",
  },
];